import axios from 'axios';

export const removeFile = ({
  id,
  removeEndpoint,
  csrfToken,
  onResponse = () => {},
  onError = () => {},
}) => {
  const removeEndpointWithParam = removeEndpoint + '/' + id;
  axios
    .post(
      removeEndpointWithParam,
      {},
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'text/html',
          'X-CSRFToken': csrfToken,
        },
      }
    )
    .then(onResponse)
    .catch(onError);
};
